import router from "routes";
import { configureOmiseSDK } from "./configureOmise";

export class PayNowFlow {
	paymentAmount = null;
	data = null;

	initializeEpayment = async () => {
		throw new Error("initializeEpayment is required");
	};

	constructor({ paymentAmount, data, initializeEpayment, createOmiseCharge }) {
		this.paymentAmount = paymentAmount;
		this.data = data;
		if (!initializeEpayment) {
			throw new Error("initializeEpayment is required");
		}
		this.initializeEpayment = initializeEpayment;

		if (!createOmiseCharge) {
			throw new Error("createOmiseCharge is required");
		}
		this.createOmiseCharge = createOmiseCharge;
		configureOmiseSDK();
	}

	async processPayment() {
		const epaymentPayload = {
			...this.data,
			omiseToken: "",
			omiseSource: "",
			payment_method: "omise_paynow",
		};

		const epaymentResponse = await this.initializeEpayment(epaymentPayload);
		if (!epaymentResponse.status == 1) {
			throw new Error("Unexpected error while creating payment record, expecting 1");
		}

		return epaymentResponse;
	}
}
